(function () {
  function init(root) {
    if (root.dataset.bbFsReady) return;
    root.dataset.bbFsReady = '1';
    var slides = Array.prototype.slice.call(root.querySelectorAll('.bb-fs__slide'));
    var bgs = Array.prototype.slice.call(root.querySelectorAll('.bb-fs__bg'));
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-bb-fs-tab]'));
    var counter = root.querySelector('[data-bb-fs-current]');
    if (slides.length < 2) return;
    var current = 0;
    var DUR = 5000;
    var timer = null;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var autoplay = root.getAttribute('data-autoplay') === 'true' && !reduce;
    root.style.setProperty('--dur', DUR / 1000 + 's');

    function paint(i) {
      var ink = getComputedStyle(slides[i]).getPropertyValue('--ink').trim();
      root.style.setProperty('--head-ink', ink || '#1e130c');
      var b = bgs[i];
      if (b && b.dataset.c1 && b.dataset.c2) {
        root.style.setProperty('--fs-bg', 'radial-gradient(70% 60% at 50% 42%, ' + b.dataset.c1 + ' 0%, ' + b.dataset.c2 + ' 100%)');
      }
    }

    function go(i, dir) {
      i = (i + slides.length) % slides.length;
      if (i === current) return;
      root.setAttribute('data-dir', dir || (i > current ? 1 : -1));
      var prev = slides[current];
      prev.classList.remove('is-active');
      prev.classList.add('is-leaving');
      prev.setAttribute('aria-hidden', 'true');
      setTimeout(function () { prev.classList.remove('is-leaving'); }, 700);
      slides[i].classList.add('is-active');
      slides[i].setAttribute('aria-hidden', 'false');
      bgs.forEach(function (b, k) { b.classList.toggle('is-active', k === i); });
      tabs.forEach(function (t, k) {
        t.classList.toggle('is-active', k === i);
        t.setAttribute('aria-selected', k === i ? 'true' : 'false');
        if (k === i) { var bar = t.querySelector('.bb-fs__tab-bar span'); if (bar) { bar.style.animation = 'none'; void bar.offsetWidth; bar.style.animation = ''; } }
      });
      if (counter) counter.textContent = ('0' + (i + 1)).slice(-2);
      current = i;
      paint(i);
      restart();
    }
    function restart() {
      clearTimeout(timer);
      if (autoplay && !root.classList.contains('is-paused')) timer = setTimeout(function () { go(current + 1, 1); }, DUR);
    }

    tabs.forEach(function (t) { t.addEventListener('click', function () { go(parseInt(t.getAttribute('data-bb-fs-tab'), 10)); }); });
    var prevBtn = root.querySelector('[data-bb-fs-prev]');
    var nextBtn = root.querySelector('[data-bb-fs-next]');
    if (prevBtn) prevBtn.addEventListener('click', function () { go(current - 1, -1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { go(current + 1, 1); });

    root.addEventListener('mouseenter', function () { root.classList.add('is-paused'); clearTimeout(timer); });
    root.addEventListener('mouseleave', function () { root.classList.remove('is-paused'); restart(); });
    root.addEventListener('focusin', function () { root.classList.add('is-paused'); clearTimeout(timer); });

    var sx = null, sy = null;
    root.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (sx === null) return;
      var dx = e.changedTouches[0].clientX - sx;
      var dy = e.changedTouches[0].clientY - sy;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) go(current + (dx < 0 ? 1 : -1), dx < 0 ? 1 : -1);
      sx = null;
    }, { passive: true });

    new IntersectionObserver(function (e) {
      if (e[0].isIntersecting) restart(); else clearTimeout(timer);
    }, { threshold: .35 }).observe(root);

    paint(0);
  }
  function boot() { document.querySelectorAll('[data-bb-fs]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
